export const dateToMilliseconds = (dateObj: Date) => {
  //return the date by parsing into milliseconds without time i.e "2021-01-28 -> 1611810000000"
  return Date.parse(
    `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}-${dateObj.getDate()}`
  )
}
